<template lang="pug">
    .game-master-profile-page
        game-master-profile(v-if="profile" :profile="profile")
        re-loading(v-else)

</template>

<script>
export default {
    name: 'game-master-profile-page',

    data() {
        return {
            profile: null,
        }
    },

    async created() {
        const { data: { data: profile } } = await axios.get(`/api/customer/user/name-id/${this.$route.params.nameDashId}`)
        this.profile = profile
    },

    mounted() {
      const stripeScript = document.createElement('script')
      stripeScript.setAttribute('src', 'https://js.stripe.com/v3/')
      document.head.appendChild(stripeScript)
    },
}
</script>
